// Browser-safe accessors over precompiled tool data.
import toolsJson from './generated/tools.json'
import type { Tool } from './types'

const tools = toolsJson as unknown as Tool[]

export function getAllTools(): Tool[] {
  return tools
}

export function getToolBySlug(slug: string): Tool | null {
  return tools.find((t) => t.slug === slug) ?? null
}
